<div
	class="time-picker-wrapper"
	[class.disabled]="disabled"
>
	<div class="label-wrapper">
		<div
			*ngIf="label"
			class="picker-label"
		>
			{{ label }}
		</div>
		<div
			*ngIf="showNotifier"
			class="notifier-wrapper"
		>
			<div class="notifier-text">+1</div>
			<mat-icon
				[matTooltip]="tooltipMessage"
				matTooltipClass="helper-tooltip"
			>
				help
			</mat-icon>
		</div>
	</div>
	<div class="vspace-4px"></div>

	<!-- Closed View -->
	<div
		class="time-display"
		[class.open]="open"
		[attr.tabindex]="disabled ? null : 0"
		(click)="toggleOpen()"
		(keydown.enter)="toggleOpen()"
		(keydown.space)="$event.preventDefault(); toggleOpen()"
		role="button"
		[attr.aria-expanded]="open"
		[attr.aria-label]="(label || ('time' | i18next: { format: 'capitalize' })) + ': ' + displayTime"
	>
		<span [class.placeholder]="!hasValue">{{ displayTime }}</span>
	</div>

	<!-- Open View as floating dropdown -->
	<div
		class="time-dropdowns"
		*ngIf="open"
	>
		<!-- HOUR -->
		<select
			[(ngModel)]="selectedHour"
			(change)="onPartChanged('hour')"
			[disabled]="disabled"
			[attr.aria-label]="'hour' | i18next: { format: 'capitalize' }"
		>
			<!-- Placeholder only while blank -->
			<option
				*ngIf="!hasValue"
				[ngValue]="null"
			>
				--
			</option>

			<option
				*ngFor="let hour of availableHours"
				[ngValue]="hour"
			>
				{{ hour }}
			</option>
		</select>

		<span>:</span>

		<!-- MINUTE -->
		<select
			[(ngModel)]="selectedMinute"
			(change)="onPartChanged('minute')"
			[disabled]="disabled"
			[attr.aria-label]="'minute' | i18next: { format: 'capitalize' }"
		>
			<!-- Placeholder only while blank -->
			<option
				*ngIf="!hasValue"
				[ngValue]="null"
			>
				--
			</option>

			<option
				*ngFor="let minute of availableMinutes"
				[ngValue]="minute"
			>
				{{ minute < 10 ? "0" + minute : minute }}
			</option>
		</select>

		<!-- PERIOD -->
		<select
			[(ngModel)]="selectedPeriod"
			(change)="onPartChanged('period')"
			[disabled]="disabled"
			[attr.aria-label]="'am or pm' | i18next"
		>
			<!-- Placeholder only while blank -->
			<option
				*ngIf="!hasValue"
				[ngValue]="null"
			>
				--
			</option>

			<option
				*ngFor="let period of periods"
				[ngValue]="period"
			>
				{{ period }}
			</option>
		</select>
	</div>
</div>
